import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/filing-review/creators/{creatorId}/configs/{id}']['DELETE'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

const deleteCreatorConfig = async ({ creatorId, id }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/filing-review/creators/{creatorId}/configs/{id}', { creatorId, id });
  const response = await noodleApiClient.delete(path);
  return response.data;
};

export default deleteCreatorConfig;
